"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3678],{

/***/ 94640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PictureWithLinkComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_core_picture_picture_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82305);
/* harmony import */ var _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65023);






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var PictureWithLinkComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(PictureWithLinkComponent, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(PictureWithLinkComponent);
    function PictureWithLinkComponent() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, PictureWithLinkComponent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(args)));
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this), "onClick", function(e) {
            var _props = _this.props, href = _props.href, src = _props.src;
            var isKeyboardEvent = (e === null || e === void 0 ? void 0 : e.screenX) === 0 && (e === null || e === void 0 ? void 0 : e.screenY) === 0;
            BigBrain("track", _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_8__.PICTURE_WITH_LINK_CLICKED, {
                kind: href,
                info1: isKeyboardEvent ? "keyboard" : "mouse",
                info2: src
            });
        });
        return _this;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(PictureWithLinkComponent, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, href = _this_props.href, target = _this_props.target, otherProps = _object_without_properties(_this_props, [
                    "href",
                    "target"
                ]);
                if (href) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: href,
                        target: target,
                        onClick: this.onClick,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_core_picture_picture_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _object_spread({}, otherProps))
                    });
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_core_picture_picture_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _object_spread({}, otherProps));
            }
        }
    ]);
    return PictureWithLinkComponent;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);

PictureWithLinkComponent.defaultProps = {
    target: "_self"
};


/***/ }),

/***/ 57578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var components_core_new_button_button_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35061);
/* harmony import */ var styles_color_consts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(273);
/* harmony import */ var constants_button_additional_text_position__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87154);



/* harmony default export */ __webpack_exports__["Z"] = ({
    buttonSize: components_core_new_button_button_component__WEBPACK_IMPORTED_MODULE_0__.MD,
    buttonText: "Button",
    isOpenLinkInNewTab: false,
    onClick: null,
    color: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WORK_OS_IRIS_COLOR_NAME,
    isWithArrow: true,
    minPadding: false,
    additionalText: null,
    additionalTextPosition: constants_button_additional_text_position__WEBPACK_IMPORTED_MODULE_2__/* .BELOW */ ._,
    additionalTextMaxWidth: null,
    iconRenderer: null,
    extraEventData: {}
});


/***/ }),

/***/ 35662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ regular_button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/new-button/button-component.js + 1 modules
var button_component = __webpack_require__(35061);
// EXTERNAL MODULE: ./segments/button-service.js
var button_service = __webpack_require__(93833);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./utils/url.js
var utils_url = __webpack_require__(8339);
// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/regular-button/regular-button.scss.js

var StyledRegularButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e633rko0"
})("&.full{width:100%;}.additional-button-text{margin-top:8px;}");

// EXTERNAL MODULE: ./segments/desktop/core-components/button/regular-button/default-props.js
var default_props = __webpack_require__(57578);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/regular-button/regular-button.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}















var isSeoFriendlyUrl = function(url) {
    var res = false;
    if (url && url.indexOf(links/* MONDAY_AUTH_DOMAIN */.NyZ) < 0) {
        res = true;
    }
    return res;
};
var RegularButton = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(RegularButton, PureComponent);
    var _super = (0,_create_super/* default */.Z)(RegularButton);
    function RegularButton(props) {
        (0,_class_call_check/* default */.Z)(this, RegularButton);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "onClick", function(e) {
            var _props = _this.props, buttonText = _props.buttonText, url = _props.url, isOpenLinkInNewTab = _props.isOpenLinkInNewTab, onClick = _props.onClick, extraEventData = _props.extraEventData, disableBigBrainEvent = _props.disableBigBrainEvent;
            var isKeyboardEvent = (e === null || e === void 0 ? void 0 : e.screenX) === 0 && (e === null || e === void 0 ? void 0 : e.screenY) === 0;
            if (!disableBigBrainEvent) {
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.REGULAR_BUTTON_CLICKED, {
                    kind: buttonText,
                    info1: isKeyboardEvent ? "keyboard" : "mouse",
                    info2: url,
                    info3: (0,utils_url.getLastPartOfUrl)(url),
                    data: extraEventData
                });
            }
            if (onClick) {
                onClick(e);
            }
            if (url && !_this.isSeoFriendlyUrl) {
                if (isOpenLinkInNewTab) {
                    window.open(url);
                } else {
                    window.location.href = url;
                }
            }
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getButtonBackgroundColor", function(color) {
            if (color === color_consts.DODGER_BLUE_COLOR_NAME || color === color_consts.SPACE_BLUE_COLOR_NAME) {
                return color_consts.WORK_OS_IRIS_COLOR_NAME;
            }
            return color;
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getButtonStrippedText", function() {
            var buttonText = _this.props.buttonText;
            var disallowedButtonChars = [
                /\s*>/g
            ];
            var strippedButtonText = buttonText;
            disallowedButtonChars.forEach(function(ending) {
                strippedButtonText = strippedButtonText.replace(ending, "");
            });
            return strippedButtonText;
        });
        _this.isSeoFriendlyUrl = isSeoFriendlyUrl(props.url);
        return _this;
    }
    (0,_create_class/* default */.Z)(RegularButton, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, buttonSize = _props.buttonSize, color = _props.color, outline = _props.outline, isWithArrow = _props.isWithArrow, iconRenderer = _props.iconRenderer, minPadding = _props.minPadding, url = _props.url, isOpenLinkInNewTab = _props.isOpenLinkInNewTab, additionalText = _props.additionalText, additionalTextPosition = _props.additionalTextPosition, additionalTextMaxWidth = _props.additionalTextMaxWidth, className = _props.className;
                var buttonStyle = button_service/* buttonStyles */.$Y[color] || {};
                var textColor = buttonStyle.textColor, backgroundColorName = buttonStyle.backgroundColorName;
                var buttonColor = this.getButtonBackgroundColor(backgroundColorName);
                var buttonStrippedText = this.getButtonStrippedText();
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRegularButton, {
                    className: classnames_default()("regular-button", buttonSize, additionalText && "additional-text additional-text-".concat(additionalTextPosition)),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(button_component/* default */.ZP, {
                            seoFriendlyUrl: this.isSeoFriendlyUrl && url,
                            isOpenLinkInNewTab: isOpenLinkInNewTab,
                            size: buttonSize,
                            onClick: this.onClick,
                            color: buttonColor,
                            textColor: textColor,
                            outline: outline,
                            isWithArrow: isWithArrow,
                            className: className,
                            iconRenderer: iconRenderer,
                            minPadding: minPadding,
                            children: buttonStrippedText
                        }),
                        additionalText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("additional-button-text", this.additionalTextPosition),
                            style: {
                                maxWidth: additionalTextMaxWidth
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                                text: additionalText
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return RegularButton;
}(react.PureComponent);
RegularButton.defaultProps = default_props/* default */.Z;
/* harmony default export */ var regular_button = ((0,generic_config_context/* withGenericConfig */.P)((0,ab_tests_context/* withAbTests */.k)(RegularButton)));


/***/ }),

/***/ 42057:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var COOKIES_POLICY_REQUIRED_COUNTRIES_ISO_CODES = (__webpack_require__(72632).COOKIES_POLICY_REQUIRED_COUNTRIES_ISO_CODES);
var CLOUDFRONT_MOBILE_HEADER = "cloudfront-is-mobile-viewer";
var CLOUDFRONT_TABLET_HEADER = "cloudfront-is-tablet-viewer";
var CLOUDFRONT_DESKTOP_HEADER = "cloudfront-is-desktop-viewer";
var CLOUDFRONT_COUNTRY_HEADER = "cloudfront-viewer-country";
var isMobileOrTablet = function(req) {
    return isMobile(req) || isTablet(req);
};
var isMobile = function(req) {
    var headers = req.headers;
    return headers[CLOUDFRONT_MOBILE_HEADER] && headers[CLOUDFRONT_MOBILE_HEADER] === "true";
};
var isTablet = function(req) {
    var headers = req.headers;
    return headers[CLOUDFRONT_TABLET_HEADER] && headers[CLOUDFRONT_TABLET_HEADER] === "true";
};
var isDesktop = function(req) {
    var headers = req.headers;
    return headers[CLOUDFRONT_DESKTOP_HEADER] && headers[CLOUDFRONT_DESKTOP_HEADER] === "true";
};
var isCookiesPolicyRequiredCountryFromServer = function(res) {
    var cloudFrontCountry = res.getHeader(CLOUDFRONT_COUNTRY_HEADER);
    return doesCountryRequireStrictCookiePolicy(cloudFrontCountry);
};
var doesCountryRequireStrictCookiePolicy = function(cloudFrontCountry) {
    return cloudFrontCountry && COOKIES_POLICY_REQUIRED_COUNTRIES_ISO_CODES.includes(cloudFrontCountry);
};
module.exports = {
    isMobileOrTablet: isMobileOrTablet,
    isDesktop: isDesktop,
    isMobile: isMobile,
    isTablet: isTablet,
    isCookiesPolicyRequiredCountryFromServer: isCookiesPolicyRequiredCountryFromServer,
    doesCountryRequireStrictCookiePolicy: doesCountryRequireStrictCookiePolicy
};


/***/ }),

/***/ 77784:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var ref = __webpack_require__(85010), isCountryInContinent = ref.isCountryInContinent, OCEANIA = ref.OCEANIA;
var ref1 = __webpack_require__(13019), USE_OLD_STORAGE_SETTINGS = ref1.USE_OLD_STORAGE_SETTINGS, WEBSITE_AB_TEST_DEBUG_COOKIE_NAME = ref1.WEBSITE_AB_TEST_DEBUG_COOKIE_NAME;
var getAbTestVariantNew = (__webpack_require__(41871).getAbTestVariantNew);
var doesCountryRequireStrictCookiePolicy = (__webpack_require__(42057).doesCountryRequireStrictCookiePolicy);
var isRunningInClient = (__webpack_require__(44566).isRunningInClient);
var ref2 = __webpack_require__(60734), SKIP_SIGN_UP_STEP_IN_PRICING_PAGE_AB_TEST = ref2.SKIP_SIGN_UP_STEP_IN_PRICING_PAGE_AB_TEST, EXIT_POP_UP_SURVEY_AB_TEST = ref2.EXIT_POP_UP_SURVEY_AB_TEST, REVIVE_EXIT_POPUP_AB_TEST = ref2.REVIVE_EXIT_POPUP_AB_TEST, PERFORMANCE_STATIC_PAGE_AB_TEST = ref2.PERFORMANCE_STATIC_PAGE_AB_TEST, BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES = ref2.BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES, DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST = ref2.DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST, PRICING_ENTERPRISE_CONTACT_SALES_AB_TEST = ref2.PRICING_ENTERPRISE_CONTACT_SALES_AB_TEST, MOBILE_STICKY_SIGNUP_AB_TEST = ref2.MOBILE_STICKY_SIGNUP_AB_TEST, WELCOME_BACK_PAGE_TEST = ref2.WELCOME_BACK_PAGE_TEST, KEEP_REGION_TEST = ref2.KEEP_REGION_TEST, CONTACT_SALES_TYPEFORM_EMEA = ref2.CONTACT_SALES_TYPEFORM_EMEA, CONTACT_SALES_TYPEFORM_ANZ = ref2.CONTACT_SALES_TYPEFORM_ANZ, HEADER_NEW_PRODUCTS_OFFERING_TEST = ref2.HEADER_NEW_PRODUCTS_OFFERING_TEST, UNLIMITED_TIME_FREE_PLAN_CTA_TEXT_TEST = ref2.UNLIMITED_TIME_FREE_PLAN_CTA_TEXT_TEST, TYPEFORM_FIRST_SCREEN_MULTIPLE_FIELDS_TEST = ref2.TYPEFORM_FIRST_SCREEN_MULTIPLE_FIELDS_TEST, STUDIO_IN_HEADER_TEST = ref2.STUDIO_IN_HEADER_TEST, ENHANCED_PRODUCTS_IN_HEADER_TEST = ref2.ENHANCED_PRODUCTS_IN_HEADER_TEST, WM_HIGH_INTENT_EXPERIENCE = ref2.WM_HIGH_INTENT_EXPERIENCE, CONTACT_SALES_FOOTER_TEST = ref2.CONTACT_SALES_FOOTER_TEST, CX_BOT_TEST = ref2.CX_BOT_TEST, GET_QUOTE_TEXT_IN_PRICING = ref2.GET_QUOTE_TEXT_IN_PRICING, CAMPAIGN_PRODUCT_HOMEPAGE_FIRST_FOLD = ref2.CAMPAIGN_PRODUCT_HOMEPAGE_FIRST_FOLD, GET_QUOTE_TEXT_AND_MODAL = ref2.GET_QUOTE_TEXT_AND_MODAL, REQUEST_DEMO_HEADER_TEST_NEW_USERS_LPS = ref2.REQUEST_DEMO_HEADER_TEST_NEW_USERS_LPS, REQUEST_DEMO_HEADER_TEST_NEW_USERS_WEBSITE_PAGES = ref2.REQUEST_DEMO_HEADER_TEST_NEW_USERS_WEBSITE_PAGES, SIGNUP_BY_PRODUCT_CAMPAIGN = ref2.SIGNUP_BY_PRODUCT_CAMPAIGN, REQUEST_DEMO_HEADER_TEST_ES = ref2.REQUEST_DEMO_HEADER_TEST_ES, REQUEST_DEMO_HEADER_TEST_FR = ref2.REQUEST_DEMO_HEADER_TEST_FR, REQUEST_DEMO_HEADER_TEST_DE = ref2.REQUEST_DEMO_HEADER_TEST_DE, ONE_TAP_GOOGLE_SIGNUP_CRM = ref2.ONE_TAP_GOOGLE_SIGNUP_CRM, REQUEST_DEMO_HEADER_NEW_TEST = ref2.REQUEST_DEMO_HEADER_NEW_TEST;
var shouldGetSkipSignUpStepInPricingAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, SKIP_SIGN_UP_STEP_IN_PRICING_PAGE_AB_TEST, sendBigBrainEvent) === "new_with_skip";
};
var shouldSeeExitPopupSurveyAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 ? arguments[1] : void 0;
    return getAbTestVariantNew(abTests, EXIT_POP_UP_SURVEY_AB_TEST, sendBigBrainEvent) === "new_with_survey";
};
var shouldSeeReviveExitPopupAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, REVIVE_EXIT_POPUP_AB_TEST.test_name, sendBigBrainEvent) === REVIVE_EXIT_POPUP_AB_TEST.new_variation_name;
};
var shouldSeeStaticPagePerformanceAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], cloudfrontViewerCountry = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (doesCountryRequireStrictCookiePolicy(cloudfrontViewerCountry)) return false;
    return getAbTestVariantNew(abTests, PERFORMANCE_STATIC_PAGE_AB_TEST.test_name, sendBigBrainEvent) === PERFORMANCE_STATIC_PAGE_AB_TEST.new_variation_name;
};
var shouldShowBiggerStorageInPricingFeatures = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], cookies = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof cookies[USE_OLD_STORAGE_SETTINGS] !== "undefined") {
        return cookies[USE_OLD_STORAGE_SETTINGS] !== "true";
    }
    return getAbTestVariantNew(abTests, BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES.test_name, sendBigBrainEvent) === BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES.new_variation_name;
};
var shouldSeeDesktopWithEnterpriseMenuAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST.test_name, sendBigBrainEvent) === DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST.new_variation_name;
};
var shouldGetEnterpriseContactUsPageAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, PRICING_ENTERPRISE_CONTACT_SALES_AB_TEST.test_name, sendBigBrainEvent) === PRICING_ENTERPRISE_CONTACT_SALES_AB_TEST.new_variation_name;
};
var shouldGetMobileStickySignupAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, MOBILE_STICKY_SIGNUP_AB_TEST.test_name, sendBigBrainEvent) === MOBILE_STICKY_SIGNUP_AB_TEST.new_variation_name;
};
var shouldGetWelcomeBackPageTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], persistantCookies = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, extraBigBrainParams = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    if (persistantCookies[WEBSITE_AB_TEST_DEBUG_COOKIE_NAME] === WELCOME_BACK_PAGE_TEST.test_name) return true;
    return getAbTestVariantNew(abTests, WELCOME_BACK_PAGE_TEST.test_name, sendBigBrainEvent, false, extraBigBrainParams) === WELCOME_BACK_PAGE_TEST.new_variation_name;
};
var shouldGetKeepRegionTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], cloudfrontViewerCountry = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    try {
        var _localStorage;
        if (isRunningInClient() && ((_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem("is_in_keep_region_test")) === "true") {
            return true;
        }
        if (isCountryInContinent(cloudfrontViewerCountry, OCEANIA)) {
            // only people from Oceanic countries should enter the test
            return getAbTestVariantNew(abTests, KEEP_REGION_TEST.test_name, sendBigBrainEvent) === KEEP_REGION_TEST.new_variation_name;
        }
    } catch (error) {
    // nothing to do - just done to protect from crashes
    }
    return false;
};
var shouldGetContactSalesTypeformEmeaTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, CONTACT_SALES_TYPEFORM_EMEA.test_name, sendBigBrainEvent) === CONTACT_SALES_TYPEFORM_EMEA.new_variation_name;
};
var shouldGetContactSalesTypeformAnzTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, CONTACT_SALES_TYPEFORM_ANZ.test_name, sendBigBrainEvent) === CONTACT_SALES_TYPEFORM_ANZ.new_variation_name;
};
var shouldHaveHeaderWithNewProductsOfferingTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, HEADER_NEW_PRODUCTS_OFFERING_TEST.test_name, sendBigBrainEvent) === HEADER_NEW_PRODUCTS_OFFERING_TEST.new_variation_name;
};
var shouldGetUnlimitedTimeCTATextTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, UNLIMITED_TIME_FREE_PLAN_CTA_TEXT_TEST.test_name, sendBigBrainEvent) === UNLIMITED_TIME_FREE_PLAN_CTA_TEXT_TEST.new_variation_name;
};
var shouldUseNewTypeformVariant = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, TYPEFORM_FIRST_SCREEN_MULTIPLE_FIELDS_TEST.test_name, sendBigBrainEvent) === TYPEFORM_FIRST_SCREEN_MULTIPLE_FIELDS_TEST.new_variation_name;
};
var shouldHaveStudioProductInHeaderTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, STUDIO_IN_HEADER_TEST.test_name, sendBigBrainEvent) === STUDIO_IN_HEADER_TEST.new_variation_name;
};
var shouldHaveEnhancedProductsInHeaderTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, ENHANCED_PRODUCTS_IN_HEADER_TEST.test_name, sendBigBrainEvent) === ENHANCED_PRODUCTS_IN_HEADER_TEST.new_variation_name;
};
var shouldGetWMHighIntentExperience = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, WM_HIGH_INTENT_EXPERIENCE.test_name, sendBigBrainEvent) === WM_HIGH_INTENT_EXPERIENCE.new_variation_name;
};
var shouldGetContactSalesInTheFooter = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, CONTACT_SALES_FOOTER_TEST.test_name, sendBigBrainEvent) === CONTACT_SALES_FOOTER_TEST.new_variation_name;
};
var shouldGetQuoteTextInPricing = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, GET_QUOTE_TEXT_IN_PRICING.test_name, sendBigBrainEvent) === GET_QUOTE_TEXT_IN_PRICING.new_variation_name;
};
var shouldDisplayCampaignProductHomepageFirstFold = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, CAMPAIGN_PRODUCT_HOMEPAGE_FIRST_FOLD.test_name, sendBigBrainEvent) === CAMPAIGN_PRODUCT_HOMEPAGE_FIRST_FOLD.new_variation_name;
};
var shouldGetQuoteTextAndModal = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, GET_QUOTE_TEXT_AND_MODAL.test_name, sendBigBrainEvent) === GET_QUOTE_TEXT_AND_MODAL.new_variation_name;
};
var shouldGetSignupByProductCampaign = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, SIGNUP_BY_PRODUCT_CAMPAIGN.test_name, sendBigBrainEvent) === SIGNUP_BY_PRODUCT_CAMPAIGN.new_variation_name;
};
var shouldRenderRequestDemoHeaderButtonEs = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, REQUEST_DEMO_HEADER_TEST_ES.test_name, sendBigBrainEvent) === REQUEST_DEMO_HEADER_TEST_ES.new_variation_name;
};
var shouldRenderRequestDemoHeaderButtonFr = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, REQUEST_DEMO_HEADER_TEST_FR.test_name, sendBigBrainEvent) === REQUEST_DEMO_HEADER_TEST_FR.new_variation_name;
};
var shouldRenderRequestDemoHeaderButtonDe = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, REQUEST_DEMO_HEADER_TEST_DE.test_name, sendBigBrainEvent) === REQUEST_DEMO_HEADER_TEST_DE.new_variation_name;
};
var shouldShowOneTapGoogleSignupCRM = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, ONE_TAP_GOOGLE_SIGNUP_CRM.test_name, sendBigBrainEvent) === ONE_TAP_GOOGLE_SIGNUP_CRM.new_variation_name;
};
var shouldRenderRequestDemoHeaderButton = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, REQUEST_DEMO_HEADER_NEW_TEST.test_name, sendBigBrainEvent) === REQUEST_DEMO_HEADER_NEW_TEST.new_variation_name;
};
module.exports = {
    shouldGetSkipSignUpStepInPricingAbTest: shouldGetSkipSignUpStepInPricingAbTest,
    shouldSeeExitPopupSurveyAbTest: shouldSeeExitPopupSurveyAbTest,
    shouldSeeReviveExitPopupAbTest: shouldSeeReviveExitPopupAbTest,
    shouldSeeStaticPagePerformanceAbTest: shouldSeeStaticPagePerformanceAbTest,
    shouldShowBiggerStorageInPricingFeatures: shouldShowBiggerStorageInPricingFeatures,
    shouldSeeDesktopWithEnterpriseMenuAbTest: shouldSeeDesktopWithEnterpriseMenuAbTest,
    shouldGetEnterpriseContactUsPageAbTest: shouldGetEnterpriseContactUsPageAbTest,
    shouldGetMobileStickySignupAbTest: shouldGetMobileStickySignupAbTest,
    shouldGetWelcomeBackPageTest: shouldGetWelcomeBackPageTest,
    shouldGetKeepRegionTest: shouldGetKeepRegionTest,
    shouldGetContactSalesTypeformEmeaTest: shouldGetContactSalesTypeformEmeaTest,
    shouldGetContactSalesTypeformAnzTest: shouldGetContactSalesTypeformAnzTest,
    shouldHaveHeaderWithNewProductsOfferingTest: shouldHaveHeaderWithNewProductsOfferingTest,
    shouldGetUnlimitedTimeCTATextTest: shouldGetUnlimitedTimeCTATextTest,
    shouldUseNewTypeformVariant: shouldUseNewTypeformVariant,
    shouldHaveStudioProductInHeaderTest: shouldHaveStudioProductInHeaderTest,
    shouldHaveEnhancedProductsInHeaderTest: shouldHaveEnhancedProductsInHeaderTest,
    shouldGetWMHighIntentExperience: shouldGetWMHighIntentExperience,
    shouldGetContactSalesInTheFooter: shouldGetContactSalesInTheFooter,
    shouldGetQuoteTextInPricing: shouldGetQuoteTextInPricing,
    shouldDisplayCampaignProductHomepageFirstFold: shouldDisplayCampaignProductHomepageFirstFold,
    shouldGetQuoteTextAndModal: shouldGetQuoteTextAndModal,
    shouldGetSignupByProductCampaign: shouldGetSignupByProductCampaign,
    shouldRenderRequestDemoHeaderButtonEs: shouldRenderRequestDemoHeaderButtonEs,
    shouldRenderRequestDemoHeaderButtonFr: shouldRenderRequestDemoHeaderButtonFr,
    shouldRenderRequestDemoHeaderButtonDe: shouldRenderRequestDemoHeaderButtonDe,
    shouldShowOneTapGoogleSignupCRM: shouldShowOneTapGoogleSignupCRM,
    shouldRenderRequestDemoHeaderButton: shouldRenderRequestDemoHeaderButton
};


/***/ })

}]);